module.exports = __webpack_public_path__ + "img/subtract_bg.faee24a7.png";